module.exports = __webpack_public_path__ + "static/img/A-android1.93f379b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/A-android1.png
// module id = 6bX9
// module chunks = 4